import { styled } from '@linaria/react'

import type { SeparatorSectionType } from './types'

export const Separator = styled.div<SeparatorSectionType>`
  width: ${(props): string => (props.fullWidth ? '100vw' : '100%')};
  border-bottom: ${(props): string => props.height || '1px'}
    ${(props): string => props.type || 'solid'}
    ${(props): string => props.color || 'var(--gray100)'};
  margin: ${(props): string => props.margin || '32px 0'};
  margin-left: ${(props): string => (props.fullWidth ? '-24px' : '0')};
`

export const Spacer = styled.div<SeparatorSectionType>`
  height: ${(props): string => props.height || '32px'};
`
